import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {deleteCandidate} from '/redux/action/candidate.action';
import {allReportData} from '/redux/selector/report.selector';

import {ReferralOfferExpiredBanner} from './ReferralOfferExpiredBanner';

export default connect(
  createStructuredSelector({
    allReportData,
  }),
  dispatch => ({
    deleteCandidate: ({candidateId, allReportData}: any) =>
      dispatch<any>(deleteCandidate({candidateId, allReportData})),
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    deleteCandidate: () => {
      const {candidateId} = ownProps;
      return dispatchProps.deleteCandidate({
        candidateId,
        allReportData: stateProps.allReportData,
      });
    },
  }),
)(ReferralOfferExpiredBanner);
